/*
 * BM v4 – Filtros en celular.
 * El tema recarga la página cada vez que se toca un filtro (y cierra el panel).
 * En celular ahora se eligen varias opciones con calma y se aplican con
 * "Ver productos" (o al cerrar el panel). En computadora no cambia nada.
 */
(function () {
  var MOBILE = 768;
  function isMobile() { return window.innerWidth < MOBILE; }

  function setup(form) {
    if (form.__bmReady) return;
    form.__bmReady = true;
    var pending = false;
    var nativeSubmit = HTMLFormElement.prototype.submit;
    var apply = form.querySelector('[data-bm-apply]');

    // El tema siempre manda el rango de precio completo (0 – máximo) aunque no se
    // toque, y Shopify lo cuenta como filtro activo. Si es el rango completo, no se envía.
    function skipFullPriceRange() {
      var range = form.querySelector('[data-range-slider]');
      var min = form.querySelector('[data-field-price-min]');
      var max = form.querySelector('[data-field-price-max]');
      if (!range || !min || !max) return;
      var dMin = parseFloat(range.getAttribute('data-se-min')) || 0;
      var dMax = parseFloat(range.getAttribute('data-se-max'));
      var vMin = min.value === '' ? dMin : parseFloat(min.value);
      var vMax = max.value === '' ? dMax : parseFloat(max.value);
      if (vMin <= dMin && (isNaN(dMax) || vMax >= dMax)) {
        min.disabled = true;
        max.disabled = true;
      }
    }

    function realSubmit() { pending = false; skipFullPriceRange(); nativeSubmit.call(form); }

    // El tema llama a form.submit() tras cada cambio: en celular solo marcamos pendiente.
    form.submit = function () {
      if (isMobile()) {
        pending = true;
        if (apply && apply.getAttribute('data-label-pending')) {
          apply.textContent = apply.getAttribute('data-label-pending');
        }
        return;
      }
      realSubmit();
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      realSubmit();
    });

    // Cerrar el panel con cambios pendientes = aplicar.
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-filters-toggle="filters-form"]');
      if (!t || !pending || !isMobile()) return;
      if (form.classList.contains('drawer--visible')) {
        realSubmit();
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-sidebar-filter-form]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
